/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { InteraccionesFarmacosDto } from '../../models/interacciones-farmacos-dto';

export interface DoctorFarmacosControllerGetInteraccionFarmacoByUuid$Params {
  interaccionUuid: string;
}

export function doctorFarmacosControllerGetInteraccionFarmacoByUuid(http: HttpClient, rootUrl: string, params: DoctorFarmacosControllerGetInteraccionFarmacoByUuid$Params, context?: HttpContext): Observable<StrictHttpResponse<InteraccionesFarmacosDto>> {
  const rb = new RequestBuilder(rootUrl, doctorFarmacosControllerGetInteraccionFarmacoByUuid.PATH, 'get');
  if (params) {
    rb.path('interaccionUuid', params.interaccionUuid, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<InteraccionesFarmacosDto>;
    })
  );
}

doctorFarmacosControllerGetInteraccionFarmacoByUuid.PATH = '/api/farmacos/interacciones/{interaccionUuid}';
